import { useEffect, useRef, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

export default function MainNavItem({navStatus,icon,label,link,grey300=false,disableArrow=false,type='normal',collapse=false,subMenu=false,mainRoute=false,setSubmenuPosition=null,setSubmenuHover=null,submenuHover=null,submenuName=false}) {


    const navigate = useNavigate();

    const [collapseState, setCollapseState] = useState(false);
    const [isParentActive, setIsParentActive] = useState(false);

    const arrow = grey300 ? 'arrow-right-300.svg':'arrow-right.svg';

    const collapsOn = 'menu-dash.svg';
    const collapsOff = 'menu-add.svg';

    const location = useLocation();
    const { hash, pathname, search } = location;
    let matchRoute;

    if((link === '/' || link === '/ar' || link === '/ar/' || link.includes('dashboard')) && (pathname === '/' || pathname === '/ar' || pathname === '/ar/' || pathname.includes('dashboard'))) {
        matchRoute = true;
    } else {
        matchRoute = link !== '/' && pathname.includes(link);
    }

    const handleLogoutAction = () => {
        window.localStorage.removeItem('token');
        window.localStorage.removeItem('b-user');
        navigate(`/auth/login`);
    }


    useEffect(()=>{
        if(pathname.includes(mainRoute[0]) || pathname.includes(mainRoute[1])) {
            setCollapseState(true);
        } else {
            setCollapseState(false);
        }

        if(link !== '/' && (pathname.includes(mainRoute[0]) || pathname.includes(mainRoute[1]))) {
            setIsParentActive(true);
        } else {
            setIsParentActive(false);
        }
        

    },[pathname,link,mainRoute])

    const checkSubMenuItemActive = (link) => {
        return link !== '/' && pathname.includes(link)
    }


    const parentRef = useRef(null);

  const updatePosition = () => {
    if (parentRef.current) {
      const rect = parentRef.current.getBoundingClientRect();
      setSubmenuPosition({
        x: rect.left + window.scrollX,
        y: rect.top + window.scrollY,
      });
    }
  };

  const handleMouseEnter = () => {
    if(!navStatus && !isParentActive) {
        updatePosition();
        setSubmenuHover(submenuName);
    }
  };

  const handleMouseLeave = () => {
    setSubmenuHover(false);
  };

  useEffect(() => {
    if (submenuHover) {
      window.addEventListener('scroll', updatePosition);
      window.addEventListener('resize', updatePosition);
    }
    return () => {
      window.removeEventListener('scroll', updatePosition);
      window.removeEventListener('resize', updatePosition);
    };
  }, [submenuHover]);



    return (
        collapse 
        ? <li className={`min-h-[59px] leading-[59px] relative ${navStatus ? '' : '!min-h-[72px] !leading-[72px] group relative'}`}
        ref={parentRef}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        >
            <div className={`block h-[59px] leading-[59px] relative ${navStatus ? '' : '!min-h-[72px] !leading-[72px]'} cursor-pointer select-none ${navStatus ? '' : 'showSubSide'}`} onClick={()=> navStatus ? setCollapseState(!collapseState) : ''}>
                <span className={`w-[24px] h-[24px] bg-center bg-no-repeat inline-block align-middle ms-[20px] me-[10px] transition-all ${isParentActive ? 'brightness-200' : ''} ${navStatus ? '' : '!w-[40px] !h-[40px] !bg-contain !ms-[31px]'}`} style={{background:"url('/assets/images/"+icon+"')"}}></span>
                {navStatus && <>
                    <span className={`inline-block text-[18px] font-[500] ${grey300 ? 'text-grey-300' : 'text-grey-400'} align-middle transition-all ${isParentActive ? '!text-white !font-[700]' : ''}`}>{label}</span>
                    <span className={`w-[24px] h-[24px] bg-center bg-no-repeat inline-block absolute end-[15px] top-[15px] transition-all ${matchRoute ? 'brightness-200' : ''} ${collapseState ? '-rotate-90' : ''}`} style={{background:"url('/assets/images/"+arrow+"')"}}></span>
                </>}
            </div>
            {subMenu && <ul className={`p-0 m-0 mt-[-5px] ps-[10px] ${collapseState ? '' : 'hidden'}`}>
                {subMenu.map((subMenuItem,index)=>{
                    return(<li key={'submenu-'+mainRoute[0]+'-'+index} className={`h-[35px] leading-[35px] relative ${navStatus ? '' : '!h-[35px] !leading-[35px]'}`}>
                            <Link to={subMenuItem.link} className={`block h-[35px] leading-[35px] relative ${navStatus ? '' : '!h-[35px] !leading-[35px]'}`} onClick={()=>type === 'logout' && handleLogoutAction()}>
                                <span className={`w-[18px] h-[18px] bg-center bg-no-repeat inline-block align-middle ms-[20px] me-[10px] transition-all ${checkSubMenuItemActive(subMenuItem.link) ? '' : 'opacity-50'} ${navStatus ? '' : '!w-[24px] !h-[24px] !bg-contain !ms-[31px]'}`} style={{background:"url('/assets/images/"+subMenuItem.icon+"')"}}></span>
                                {navStatus && <>
                                    <span className={`inline-block text-[16px] font-[400] ${grey300 ? 'text-grey-300' : 'text-grey-400'} align-middle transition-all ${checkSubMenuItemActive(subMenuItem.link) ? '!text-white !font-[700]' : ''}`}>{subMenuItem.label}</span>
                                </>}
                            </Link>
                        </li>)
                })}
            </ul>}
        </li>
        : <li className={`h-[59px] leading-[59px] relative ${navStatus ? '' : '!h-[72px] !leading-[72px]'}`}>
            {matchRoute && <span className={`absolute w-[4px] h-[40px] start-0 top-[10px] bg-center bg-no-repeat block ${navStatus ? '' : '!top-[16px]'}`} style={{background:"url('/assets/images/main-active.svg')"}}></span>}
            <Link to={link} className={`block h-[59px] leading-[59px] relative ${navStatus ? '' : '!h-[72px] !leading-[72px]'}`} onClick={()=>type === 'logout' && handleLogoutAction()}>
                <span className={`w-[24px] h-[24px] bg-center bg-no-repeat inline-block align-middle ms-[20px] me-[10px] transition-all ${matchRoute ? 'brightness-200' : ''} ${navStatus ? '' : '!w-[40px] !h-[40px] !bg-contain !ms-[31px]'}`} style={{background:"url('/assets/images/"+icon+"')"}}></span>
                {navStatus && <>
                    <span className={`inline-block text-[18px] font-[500] ${grey300 ? 'text-grey-300' : 'text-grey-400'} align-middle transition-all ${matchRoute ? '!text-white !font-[700]' : ''}`}>{label}</span>
                    {!disableArrow && <span className={`w-[24px] h-[24px] bg-center bg-no-repeat inline-block absolute end-[15px] top-[15px] transition-all ${matchRoute ? 'brightness-200' : ''}`} style={{background:"url('/assets/images/"+arrow+"')"}}></span>}
                </>}
            </Link>
        </li>
    )

}